// Types shared across TeamStatsBarChart sub-components

// TeamGameData re-exported from shared for existing consumers
export type { TeamGameData } from '@parlay-picker/shared/statsChart';

export interface ChartDataPoint {
  value: number;
  date?: string;
  gameNumber: number;
  opponent?: string;
  isHome: boolean;
  teamScore: number;
  opponentScore: number;
  won: boolean;
  label: string;
  compactLabel: string;
  dateFormatted: string;
  /** False when period data is missing and full-game fallback is used */
  hasPeriodData: boolean;
}

export interface TeamStatsBarChartProps {
  recentGames?: import('@parlay-picker/shared/statsChart').TeamGameData[];
  h2hGames?: import('@parlay-picker/shared/statsChart').TeamGameData[];
  propLine: number;
  propType: 'spread' | 'total' | 'moneyline';
  teamName?: string;
  opponentAbbr?: string;
  overUnder?: string | null;
  /** True when the user has changed the line from the initial value */
  isCustomLine?: boolean;
  /** Market key for period-specific charts (e.g., 'totals_h1', 'spreads_q3') */
  marketKey?: string;
}

export type ViewMode = 'L5' | 'L10' | 'L20' | 'H2H';

export const VIEW_MODES: readonly ViewMode[] = ['L5', 'L10', 'L20', 'H2H'];
